import React from 'react';
import styled from 'styled-components';

const Backdrop = ({ opened, close }) => (
  <Wrapper type="button" onClick={close} opened={opened} aria-label="Fermer la fenêtre" />
);

const Wrapper = styled.button`
  position: fixed;
  inset: 0;
  z-index: 2000;
  width: 100%;
  height: 100%;
  border: 0;
  background: rgba(7, 25, 42, 0.66);
  backdrop-filter: blur(4px);
  opacity: ${({ opened }) => (opened ? 1 : 0)};
  visibility: ${({ opened }) => (opened ? 'visible' : 'hidden')};
  transition: opacity 150ms ease, visibility 150ms ease;
  cursor: default;
`;

export default Backdrop;
